/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';

const borderColor = '#00519C';

const styles = StyleSheet.create({
	tableContainer: {
		marginTop: 24,
		borderWidth: 1,
		borderColor: borderColor,
	},

	container: {
		flexDirection: 'row',
		backgroundColor: '#00519C',
		color: '#fff',
		minHeight: 28,
		alignItems: 'center',
	},

	headerCell: {
		fontSize: 9,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: '#ffffff',
		justifyContent: 'center',
		display: 'flex',
	},

	id: {
		width: '8%',
		textAlign: 'center',
	},

	name: {
		width: '20%',
		textAlign: 'left',
	},

	datetimeFrom: {
		width: '18%',
		textAlign: 'center',
	},

	datetimeTo: {
		width: '18%',
		textAlign: 'center',
	},

	latestSchedule: {
		width: '14%',
		textAlign: 'center',
	},

	userName: {
		width: '22%',
		textAlign: 'left',
		borderRightWidth: 0,
	},
});

const paginate = (array, perPage) => {
	const pages = [];

	for (let i = 0; i < array.length; i += perPage) {
		pages.push(array.slice(i, i + perPage));
	}

	return pages;
};

const InvoiceItemsTable = (props) => {
	const itemsPerPage = 10;
	const pages = paginate(props.invoice || [], itemsPerPage);

	return (
		<>
			{pages.map((pageData, pageIndex) => (
				<React.Fragment key={pageIndex}>
					
					{/* break only after first page */}
					{pageIndex > 0 && <View break />}

					<View wrap>
						{/* Header */}
						<View style={styles.container}>
							
							<Text style={[styles.headerCell, styles.id]}>
								ID
							</Text>

							<Text style={[styles.headerCell, styles.name]}>
								Name
							</Text>

							<Text style={[styles.headerCell, styles.datetimeFrom]}>
								From Date
							</Text>

							<Text style={[styles.headerCell, styles.datetimeTo]}>
								To Date
							</Text>

							<Text style={[styles.headerCell, styles.latestSchedule]}>
								Latest Schedule
							</Text>

							<Text style={[styles.headerCell, styles.userName]}>
								User Name
							</Text>

						</View>

						{/* Rows */}
						<InvoiceTableRow data={pageData} />
					</View>
				</React.Fragment>
			))}
		</>
	);
};

export default InvoiceItemsTable;